import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { HeroSection } from "@/components/landing/HeroSection";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { RitualSection } from "@/components/landing/RitualSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { CTASection } from "@/components/landing/CTASection";
import { Footer } from "@/components/landing/Footer";

const Index = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Capture referral code from URL (?ref=CODE) and persist for signup
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem("kosh_referral_code", ref.toUpperCase());
    }
    checkUser();
  }, []);


  const checkUser = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    } catch (error) {
      console.error("Error checking user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetStarted = async () => {
    if (!user) {
      navigate("/auth");
      return;
    }

    try {
      const { data: businesses } = await supabase
        .from("businesses")
        .select("id")
        .eq("owner_id", user.id)
        .limit(1);

      if (businesses && businesses.length > 0) {
        navigate(`/business/${businesses[0].id}`);
      } else {
        navigate("/onboarding");
      }
    } catch (error) {
      console.error("Error checking businesses:", error);
      navigate("/dashboard");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="relative">
          <div className="w-12 h-12 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background font-body">
      <HeroSection user={user} onGetStarted={handleGetStarted} />
      <ProblemSection />
      <RitualSection />
      <FeaturesSection />
      <TestimonialsSection />
      <PricingSection user={user} />
      <CTASection user={user} onGetStarted={handleGetStarted} />
      <Footer />
    </div>
  );
};

export default Index;
